export default __webpack_public_path__ + "9bd8ed75f144780483893fbee80cc784.png";